// Matriset global http error interceptor
//  - Shared between tiekuntarekisteri (sastamala repository) and matriweb frontend
//  - SYNCHRONIZE ANY UPDATES TO BOTH REPOSITORIES
// Changelog
//  - v0.x - slightly different versions in each repostory
//
//  - v1.0 - synchronized versions, new features
//    * specific handling for 403 ("access level not enough")
//    * no alert dialog for 404 if rejection.config.ignoreNotFound is set
//      usage: set ignoreNotFound in resource config (static for the same resource always)
//    * special handling for case where response status is not available,
//      likely happening in cases where expected response is JSON but returned data is not
//      (added on matriweb side)
//
//  - v1.1 (12 Aug 2018)
//    * Add generic mechanism to tell the interceptor to not intercept specific HTTP statuses.
//      Can be used to handle errors in controller in a controlled manner.
//
// register the interceptor as a service
// http://djds4rce.wordpress.com/2013/08/13/understanding-angular-http-interceptors/
// http://blog.getbrandid.com/2013/03/22/your-angular-js-directives-will-break-when-minified-this-is-how-you-write-directives-likeaboss/
import angular from 'angular';
export default angular.module('httpErrorInterceptor', []).factory('HttpErrorInterceptor', ['$q', function ($q) {
        return {
            // optional method
            'requestError': function (rejection) {
                console.log('httpErrorInterceptor: requestError');
                return $q.reject(rejection);
            },
            // optional method
            'responseError': function (rejection) {
                var _a;
                if (((_a = rejection.data) === null || _a === void 0 ? void 0 : _a.type) === 'mwErrorResponse') {
                    // Matriweb error frame
                    const message = `VIRHE: ${rejection.data.message}\n\nVirhekoodi: ${rejection.data.errorCode}`;
                    window.alert(message);
                    return $q.reject(rejection);
                }
                if (rejection.status == 401) {
                    window.alert('Kirjautuminen on vanhentunut tai et ole kirjautunut sisään. Ole hyvä ja kirjaudu uudelleen.');
                    window.location.href = '../'; // what was the point of this?
                    return $q.reject(rejection);
                }
                if (rejection.status == 403) {
                    window.alert('Käyttöoikeudet eivät riitä toiminnon suorittamiseen.\n\nTarvittaessa ota yhteyttä helpdesk@matriset.fi.');
                    return $q.reject(rejection);
                }
                if (rejection.status == 404 && rejection.config.ignoreNotFound) {
                    return $q.reject(rejection);
                }
                // Interception of specific status can be disabled (f.e. to handle errors in controller)
                // TODO: migrate rejection.config.ignoreNotFound to use this more generic mechanism
                //       needs to be tested in tkr
                if (rejection.config && rejection.config.noIntercept && rejection.config.noIntercept.indexOf(rejection.status) != -1) {
                    return $q.reject(rejection);
                }
                if (rejection.status === 0 || rejection.status === -1) {
                    // 0 seems to be "cancelled", no point showing an error in that case
                    // update: also -1 seems same, as of Angular 1.4.8
                }
                else if (rejection.status) {
                    // some HTTP status is given
                    const message = rejection.config.method + ' ' + rejection.config.url + '\nERROR ' + rejection.status;
                    window.alert(message);
                }
                else {
                    // this is most likely a parsing error for 2xx response...
                    // happens for example if PHP notices are output in the response
                    window.alert('Response parse ERROR -> contact helpdesk@matriset.fi');
                }
                return $q.reject(rejection);
            }
        };
    }]).config(['$httpProvider', function ($httpProvider) {
        $httpProvider.interceptors.push('HttpErrorInterceptor');
    }])
    .name;
